

import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link as RouterLink, Redirect, 
  // useNavigate 
} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import {
  Box,
  Container,
    Button
} from '@material-ui/core';



//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import CreditStepper from 'src/materials/CreditStepper';
import StepProgress from 'src/materials/Verify/StepProgress';
import StepContent from 'src/materials/Verify/StepContent';

import { SET_BACKBTN } from 'src/redux/actions/types';

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [values, setValues] = useState({
    phone: ''
  })
  const dispatch = useDispatch();

// const navigate = useNavigate();
const { isLoggedIn, user } = useSelector(state => state.auth);


useEffect(() => {
  dispatch({
    type: SET_BACKBTN,
    payload: '/app/dashboard'
  })
}, [])



  return (
    <>
      <Helmet>
        <title>Login | 
          {/* Transac */}
          GCheck
          </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          // display: 'flex',
          // flexDirection: 'column',
          height: '100%',
          // justifyContent: 'center'
        }}
      >
          <StepContent/>
      </Box>
    </>
  );
};

export default Login;

